import React from 'react';
import Messages from '../../mweb/Messages/Messages';
import Icon from '../../mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import { getSubscriptionRoute } from '../../mweb/Subscription/subscription.routes';

const Summary = props => {
  const { summary } = props;

  const changeAction = getSubscriptionRoute('addressList');
  return (
    <div className="subsc-summary">
      {summary?.upfrontDiscount && (
        <div className="std-margin-all">
          <Messages message={summary.upfrontDiscount} type="success" />
        </div>
      )}
      {summary?.timeSlots && (
        <div className="std-margin-all">
          <Messages
            message={`Delivery slot: ${summary.timeSlots} on subscribed day(s)`}
            type="info"
          />
        </div>
      )}
      <div className="subsc-summary--summary-box">
        {summary?.summaryOrder.map(detail => {
          if (!detail.amount && detail.hideEmpty) return false;
          return (
            <div
              className="subsc-summary--summary-box--item"
              style={{ color: detail.hexcolors }}
              key={detail.key}
            >
              <div className="key">{detail.text}</div>
              {detail.key === 'deliveryCharges' && (
                <div className="value">
                  {detail.amount === 0 ? (
                    <span className="discount">FREE</span>
                  ) : (
                    <span>&#8377;{detail.amount}</span>
                  )}
                </div>
              )}
              {detail.key !== 'deliveryCharges' && (
                <div className="value">
                  {detail.discount ? '- ' : ''}&#8377;
                  {detail.amount}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="subsc-summary--weeks">
        {summary?.weeks.map(w => {
          if (!w.weekItemCount > 0) return false;
          return (
            <React.Fragment key={w.title}>
              <div className="subsc-summary--weeks--header">
                <div className="subsc-summary--weeks--header--title">
                  <Icon class="icon-subscription-calendar" size={15} />
                  {w.title}
                </div>
                <div className="subsc-summary--weeks--header--date">
                  {w.range}
                </div>
                <div className="subsc-summary--weeks--header--divider" />
              </div>
              {w.days?.map(d => {
                if (d.subscriptionItems?.length) {
                  return (
                    <div className="subsc-summary--weeks--week" key={d.date}>
                      {d.subscriptionItems.map(sku => {
                        // const [sku] = prod.skus;
                        return (
                          <div
                            className="subsc-summary--weeks--item"
                            key={sku.sku}
                          >
                            <div className="subsc-summary--weeks--item--day">
                              {d.day.substr(0, 3)}
                            </div>
                            <div className="subsc-summary--weeks--item--details">
                              <div className="subsc-summary--weeks--item--details--name">
                                {sku.productName}
                              </div>
                              <div>
                                {`${sku.quantityType} (${sku.inCartQty} qty)`}{' '}
                              </div>
                            </div>
                            <div className="subsc-summary--weeks--item--price">
                              {sku.onSale && sku.retailPrice > sku.salePrice ? (
                                <React.Fragment>
                                  <span className="striked">{`₹${sku.retailPrice}`}</span>
                                  <span className="final">{`₹${sku.salePrice}`}</span>
                                </React.Fragment>
                              ) : (
                                <div className="final">{`₹${sku.retailPrice}`}</div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                } else return false;
              })}
            </React.Fragment>
          );
        })}
      </div>
      {summary?.deliveryAddress && (
        <div className="subsc-summary--address-detail">
          <div className="subsc-summary--address-detail--address">
            <Icon
              size={30}
              class="icon-location-bar-location-marker flex-shrink-0"
            />
            <div className="subsc-summary--address-detail--primary-text ellipsis">
              {summary.deliveryAddress.addressType ||
                summary.deliveryAddress.area}
            </div>
            {summary.completeAddressesList?.length > 0 && (
              <Link
                to={changeAction}
                className="button action-link more flex-shrink-0"
              >
                Change
              </Link>
            )}
          </div>
          <div className="subsc-summary--address-detail--secondary-text ellipsis">
            {summary.deliveryAddress.addressLine1 ||
              summary.deliveryAddress.mapLocation ||
              summary.deliveryAddress.addressLine2}
          </div>
        </div>
      )}
    </div>
  );
};

export default Summary;
